import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../Services/apiService";
import { error } from "jquery";


export const AddDirectCosts = createAsyncThunk("DirectCosts/AddDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DirectCosts/AddDirectCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)


export const GetDirectCosts = createAsyncThunk("DirectCosts/GetDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DirectCosts/GetDirectCostsAndMonthById", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const DeleteDirectCosts = createAsyncThunk("DirectCosts/DeleteDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DirectCosts/DeleteDirectCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)



export const UpdateDirectCosts = createAsyncThunk("DirectCosts/UpdateDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DirectCosts/UpdateDirectCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const GetABI_AB_ItemTypeDirectCosts = createAsyncThunk("DirectCosts/GetABI_AB_ItemTypeDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DropDowns/GetABI_AB_ItemTypeDirectCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field
            //console.log(data, "sdsdwwwwwwwwwwdsd");

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)


export const ValidationDirectCosts = createAsyncThunk("DirectCosts/ValidationDirectCosts",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DirectCosts/ValidationDirectCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field
            if (response.data.success === true) {
                const arrayValidate = response.data.result.map((ele, ind) => {
                    return ele.code;
                });

                return arrayValidate; // Return the extracted data
            }
            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)


const DirectCostsReducer = createSlice({
    name: "DirectCosts",
    initialState: {
        addDirectCosts: {},
        lodingDirectCosts: false,
        errorDirectCosts: null,


        getDirectCosts: {},
        lodinggetDirectCosts: false,
        errorgetDirectCosts: null,

        deleteDirectCosts: {},
        lodingdeleteDirectCosts: false,
        errordeleteDirectCosts: null,


        UpdateDirectCosts: {},
        lodingUpdateDirectCosts: false,
        errorUpdateDirectCosts: null,

        ItemTypeDirectCosts: [],
        lodingItemTypeDirectCosts: false,
        errorItemTypeDirectCosts: null,

        ItemTypeDirectCostsFilter: [],


        validationDirectCosts: [],
        lodingvalidationDirectCosts: false,
        errorvalidationDirectCosts: null,


    }, reducers: {
        ItemTypeDirectCostsListFilter: (state, action) => {
            //console.log(state.ItemTypeDirectCosts, "sdsdwwwwwww");


            if (state.ItemTypeDirectCosts != undefined) {
                let result = state.ItemTypeDirectCosts.filter((ele, ind) => {
                    return ele.bI_AB_ItemTypeDirectCostsId == action.payload
                })

                state.ItemTypeDirectCostsFilter = result[0]
            }


        },

        setClearValidationList:(state,action)=>{
            state.validationDirectCosts=[]
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(AddDirectCosts.pending, (state, action) => {
                state.lodingDirectCosts = true;
                state.addDirectCosts = action.payload;
                state.errorDirectCosts = null;
            })
            .addCase(AddDirectCosts.fulfilled, (state, action) => {
                state.lodingDirectCosts = false;
                state.addDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(AddDirectCosts.rejected, (state, action) => {
                state.lodingDirectCosts = false;
                state.errorDirectCosts = action.payload;
            })
        ////////////////////////////////////////////////////
        builder
            .addCase(GetDirectCosts.pending, (state, action) => {
                state.lodinggetDirectCosts = true;
                state.getDirectCosts = action.payload;
                state.errorDirectCosts = null;
            })
            .addCase(GetDirectCosts.fulfilled, (state, action) => {
                state.lodinggetDirectCosts = false;
                state.getDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetDirectCosts.rejected, (state, action) => {
                state.lodinggetDirectCosts = false;
                state.errorgetDirectCosts = action.payload;
            })

        //////////////////////////////////////////////////
        builder
            .addCase(DeleteDirectCosts.pending, (state, action) => {
                state.lodingdeleteDirectCosts = true;
                state.deleteDirectCosts = action.payload;
                state.errordeleteDirectCosts = null;
            })
            .addCase(DeleteDirectCosts.fulfilled, (state, action) => {
                state.lodingdeleteDirectCosts = false;
                state.deleteDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(DeleteDirectCosts.rejected, (state, action) => {
                state.lodingdeleteDirectCosts = false;
                state.errordeleteDirectCosts = action.payload;
            })

        ////////////////////////////////////////////////////

        builder
            .addCase(UpdateDirectCosts.pending, (state, action) => {
                state.lodingUpdateDirectCosts = true;
                state.UpdateDirectCosts = action.payload;
                state.errorUpdateDirectCosts = null;
            })
            .addCase(UpdateDirectCosts.fulfilled, (state, action) => {
                state.lodingUpdateDirectCosts = false;
                state.deleteDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(UpdateDirectCosts.rejected, (state, action) => {
                state.lodingUpdateDirectCosts = false;
                state.errorUpdateDirectCosts = action.payload;
            })

        ///////////////////////////////////////////////////////

        builder
            .addCase(GetABI_AB_ItemTypeDirectCosts.pending, (state, action) => {
                state.lodingItemTypeDirectCosts = true;
                state.ItemTypeDirectCosts = action.payload;
                state.errorItemTypeDirectCosts = null;
            })
            .addCase(GetABI_AB_ItemTypeDirectCosts.fulfilled, (state, action) => {
                state.lodingItemTypeDirectCosts = false;
                state.ItemTypeDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetABI_AB_ItemTypeDirectCosts.rejected, (state, action) => {
                state.lodingItemTypeDirectCosts = false;
                state.errorItemTypeDirectCosts = action.payload;
            })

        ///////////////////////////////////////////////////////////////////
        builder
            .addCase(ValidationDirectCosts.pending, (state, action) => {
                state.lodingvalidationDirectCosts = true;
                state.validationDirectCosts = action.payload;
                state.errorvalidationDirectCosts = null;
            })
            .addCase(ValidationDirectCosts.fulfilled, (state, action) => {
                state.lodingvalidationDirectCosts = false;
                state.validationDirectCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(ValidationDirectCosts.rejected, (state, action) => {
                state.lodingvalidationDirectCosts = false;
                state.errorvalidationDirectCosts = action.payload;
            })
    }
})

export const { ItemTypeDirectCostsListFilter ,setClearValidationList} = DirectCostsReducer.actions
export default DirectCostsReducer.reducer
